package io.github.dautovicharis.charts.app.demo

import androidx.compose.ui.unit.dp

actual fun chartWidth() = 400.dp
